<!--
  navItem „Basisdaten“ — Zuordnung und Herkunft des Provisionssatzes.
  Berater und Vertrag tragen im Datensatz nur eine ID; beide werden aufgelöst und zeigen bei
  einem Fehlschlag lieber gar keinen Namen als einen möglicherweise falschen.
  Die Provisionsmatrix ermittelt der Lauf; sie trägt bis dahin „nicht berechnet“.
-->
<div class="cp-provision-contract-agent-base-data">

    <cp-provision-object-data
            objectType="cp.ProvisionContractAgent"
            [objectId]="provisionContractAgentId"
            widgetAlias="cp.contractAgent.baseData"
            widgetTitle="Basisdaten"
            [fields]="fields"
            [pendingFields]="pendingFields"
            [nameResolutions]="nameResolutions"
            [columns]="columns"
            emptyText="Kein Provisionssatz ausgewählt.">
    </cp-provision-object-data>

</div>
